import ky, { HTTPError } from "ky";

const BASE = process.env.NEXT_PUBLIC_API_BASE_URL || "https://whb-api.lexiglobal.my";

type ApiCallOptions = {
  body?: unknown;
  token?: string | null;
};

async function callApi<T>(path: string, { body, token }: ApiCallOptions = {}): Promise<T> {
  const payload: Record<string, unknown> = { ...(body as object ?? {}) };
  if (token) payload.token = token;

  try {
    const response = await ky.post(`${BASE}${path}`, { json: payload, timeout: 30000 });
    return (await response.json()) as T;
  } catch (err) {
    if (err instanceof HTTPError) {
      const text = await err.response.text();
      throw new Error(`API ${err.response.status}: ${text}`);
    }
    throw err;
  }
}

export const api = {
  post: callApi,
};
